import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * Shop tools filters: click-to-open on all breakpoints.
 * Native capture listener survives pjax DOM swaps; boot re-strips parent .click after ajax.
 */
(function ($) {
  var XM = window.XTSThemeModule = window.XTSThemeModule || {};
  XM.$document = XM.$document || $(document);
  function patchWidgets() {
    document.querySelectorAll('.xts-shop-tools-widget').forEach(function (el) {
      el.classList.add('xts-event-click');
    });
    $('.xts-shop-tools-widget .xts-tools-widget-title').off('click');
  }
  function onTitleClick(e) {
    var title = e.target.closest('.xts-shop-tools-widget .xts-tools-widget-title');
    if (!title) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var widget = title.closest('.xts-shop-tools-widget');
    if (!widget) {
      return;
    }
    if (widget.classList.contains('xts-opened')) {
      widget.classList.remove('xts-opened');
    } else {
      document.querySelectorAll('.xts-shop-tools-widget.xts-opened').forEach(function (w) {
        w.classList.remove('xts-opened');
      });
      widget.classList.add('xts-opened');
    }
  }
  function onOutsideClick(e) {
    if (e.target.closest('.xts-shop-tools-widget')) {
      return;
    }
    document.querySelectorAll('.xts-shop-tools-widget.xts-opened').forEach(function (w) {
      w.classList.remove('xts-opened');
    });
  }
  if (!window.__childthemeShopFilterListeners) {
    window.__childthemeShopFilterListeners = true;
    document.addEventListener('click', onTitleClick, true);
    document.addEventListener('click', onOutsideClick, false);
  }
  function boot() {
    if (!document.querySelector('.xts-shop-tools-widget')) {
      return;
    }
    patchWidgets();
  }
  function afterShopUpdate() {
    XM.shopToolsFilters = boot;
    boot();
    window.setTimeout(boot, 0);
    window.setTimeout(boot, 50);
  }
  XM.shopToolsFilters = boot;
  $(boot);
  $(window).on('load', boot);
  XM.$document.on('xtsPjaxComplete', afterShopUpdate);
  XM.$document.on('pjax:complete', afterShopUpdate);
})(jQuery);